/** Tab ids for the lead record page (shared by route + OS window). */
export type LeadDetailTabId = "overview" | "tasks" | "artefacts";

const LEAD_DETAIL_TABS: LeadDetailTabId[] = ["overview", "tasks", "artefacts"];

export function parseLeadDetailTab(value: unknown): LeadDetailTabId | undefined {
  if (typeof value !== "string") return undefined;
  return LEAD_DETAIL_TABS.includes(value as LeadDetailTabId)
    ? (value as LeadDetailTabId)
    : undefined;
}
